import { render, staticRenderFns } from "./box-input-button.vue?vue&type=template&id=04834b72&scoped=true&"
import script from "./box-input-button.vue?vue&type=script&lang=js&"
export * from "./box-input-button.vue?vue&type=script&lang=js&"
import style0 from "./box-input-button.vue?vue&type=style&index=0&id=04834b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04834b72",
  null
  
)

export default component.exports